module.exports = __webpack_public_path__ + "static/external-communication-overview-94ef9c7ff4811be8a70d6502674431a6.png";